<div class="container panel">
  <ng-container *ngIf="!isContentLoading">

  <div class="row header">
    <div class="col-11 heading">Multiple Offers</div>
    <img class="col-1 cancel-img" src="../../../assets/svg/cancel-icon.svg"
    (click)="clickEvent('cancel',{},-1)" />
  </div>
  <div class="row img-section">
    <div class="img-holder col-2">
      <img *ngIf="panelDetails?.img" [src]="panelDetails?.img" />
      <img
        *ngIf="!panelDetails?.img"
        src="../../../assets/images/image-coming-soon.png"
      />
    </div>
    <div class="img-holder-heading col-8">
      {{ panelDetails?.title }}
    </div>
  </div>
  <div *ngIf="panelDetails?.list" class="scroll-container">


  <div  *ngFor="let elem of panelDetails?.list;let i = index" class="row offer-row">

    <div  class="item-container"
    [ngClass]="(windowSize === 'mobile' || windowSize === 'tablet')?
    'width-50':''"
    >
      {{ elem?.attributes?.title }}
    </div>
    <div class="btn-container"
    [ngClass]="(windowSize === 'mobile' || windowSize === 'tablet')?
    'width-50':''">
      <app-poshvine-button
        [text]="
          windowSize === 'mobile' || windowSize === 'tablet'
            ? 'Claim'
            : 'Claim Offer'
        "
        (click)="clickEvent('claim',elem,i)"
        [isDisabled]="!elem.attributes.claimable"
      ></app-poshvine-button>
      <app-poshvine-button
        [type]="'secondary'"
        [text]="'Know More'"
        [size]="
          windowSize === 'mobile' || windowSize === 'tablet'
            ? 'small'
            : 'medium'
        "
        (click)="clickEvent('knowmore',elem,i)"
      ></app-poshvine-button>

    </div>
  </div>
</div>
</ng-container>
<ng-container *ngIf="isContentLoading">
  <app-loader-cirle [isTransparent]="true"></app-loader-cirle>
</ng-container>
</div>
